<template lang="pug">
.v-catalog-compare.catalog.catalog--compare(:class="{'catalog--initialized': initialized, 'catalog-compare--head-fixed': headFixed}")
	v-loader(:loading="loading")
	.container
		template(v-if="!catalog || (catalog && catalog.items && catalog.items.length === 0)")
			.page-title.page-title--flex
				h1.page-title__value Сравнение товаров
			.catalog__placeholder
				p.catalog__placeholder-title В сравнении пока ничего нет
				p.catalog__placeholder-text
					| Добавляйте товары в Сравнение с помощью
					svg.svg-icon.catalog__placeholder-icon
						use(xlink:href="#svg-icon-compare")

		template(v-if="catalog && catalog.items && catalog.items.length")
			.page-title.page-title--flex
				h1.page-title__value(v-if="catalog.title") {{catalog.title}}
					span.page-title__quantity(v-if="catalog && catalog.items && catalog.items.length")
						| {{catalog.items.length}} {{pluralize(catalog.items.length, 'товар', ['', 'а', 'ов'])}}
				button.link(v-if="catalog && catalog.items && catalog.items.length" type="button" @click="reset") Очистить все
			.catalog__compare-layout(v-if="catalog.items && catalog.items.length")

				.catalog-compare__head.catalog-compare__head--nav(ref="headNav")
					.catalog-compare__head-container
						.catalog-compare__head-layout
							.catalog-compare__head-aside
								.catalog-compare__head-mod
							.catalog-compare__head-main(@touchstart='dragStart' @touchend='dragEnd' @touchmove='dragMove')
								button.catalog-compare__arrow.catalog-compare__arrow--prev(type='button' @click='slideItemsBack' :class='{disabled: isPrevArrowDisabled()}')
									v-svg-icon.catalog-compare__arrow-icon(icon="slide-left")
								button.catalog-compare__arrow.catalog-compare__arrow--next(type='button' @click='slideItemsForward' :class='{disabled: isNextArrowDisabled()}')
									v-svg-icon.catalog-compare__arrow-icon(icon="slide-right")
								.catalog-compare__head-items(v-if='catalog.items')
									.catalog-compare__head-items-grid(:style="{'transform': `translate3d(${currentSlideOffset},0,0) translateX(${dragOffset}px)`, 'transition': computedTransition}")
										.catalog-compare__head-item(v-for='item in catalog.items')
											v-product(template="compare-grid-small" :product="item")

				.catalog__compare-body.flc
					.catalog-compare.flc(@scroll="tableScroll" ref="scrollContainer")
						.catalog-compare__head(:style="{'width': computedWidth}")
							.catalog-compare__head-layout
								.catalog-compare__head-aside
									.catalog-compare__head-mod
										v-field(:field="{type: 'tumbler-list', options: [{'value': '1', 'text': 'Только различия'}]}"
											v-model="excludeSimilar"
											@update:model-value="recalcParams")

								.catalog-compare__head-main(@touchstart="dragStart" @touchend="dragEnd" @touchmove="dragMove")
									button.catalog-compare__arrow.catalog-compare__arrow--prev(type="button" @click='slideItemsBack' :class='{disabled: isPrevArrowDisabled()}')
										v-svg-icon.catalog-compare__arrow-icon(icon="slide-left")
									button.catalog-compare__arrow.catalog-compare__arrow--next(type="button" @click='slideItemsForward' :class='{disabled: isNextArrowDisabled()}')
										v-svg-icon.catalog-compare__arrow-icon(icon="slide-right")
									.catalog-compare__head-items(v-if='catalog.items')
										.catalog-compare__head-items-grid(:style="{'transform': `translate3d(${currentSlideOffset},0,0) translateX(${dragOffset}px)`, 'transition': computedTransition}")
											.catalog-compare__head-item(v-for="item in catalog.items")
												v-product(template="compare-grid" :product="item")

						.catalog-compare__head-placeholder(ref='headPlaceholder')
						.catalog-compare__body(ref='compareBody' @touchstart='dragStart' @touchend='dragEnd' @touchmove='dragMove' :style="{'width': computedWidth}")
							.catalog-compare__body-group
								.catalog-compare__table
									.catalog-compare__table-row
										.catalog-compare__table-aside.catalog-compare__table-aside--bold Цена
										.catalog-compare__table-main
											.catalog-compare__table-main-grid(:style="{'transform': 'translate3d('+currentSlideOffset+',0,0) translateX('+dragOffset+'px)', 'transition': computedTransition}")
												.catalog-compare__table-main-cell(v-for='catalogItem in catalog.items')
													v-price(:price="catalogItem.price")
							.catalog-compare__body-group(v-for='paramGroup in paramGroups' :class="{'open': paramGroup.open}")
								.catalog-compare__body-group-header
									.catalog-compare__body-group-header-title {{paramGroup.title}}
								.catalog-compare__table
									.catalog-compare__table-row(v-for='param in paramGroup.params')
										.catalog-compare__table-aside {{param.title}}
										.catalog-compare__table-main
											.catalog-compare__table-main-grid(:style="{'transform': 'translate3d(' + currentSlideOffset + ',0,0) translateX(' + dragOffset + 'px)', 'transition': computedTransition}")
												.catalog-compare__table-main-cell(v-for='value in param.values') {{value ? value.text : '-'}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import breakpoints from '../scripts/breakpoints';
import {mapGetters} from 'vuex';
import controller from '../scripts/controller/controller';

export default {
	mixins: [
		sourceMixin,
		formattingMixin
	],

	data() {
		return {
			catalog: {
				items: null,
				remote: null
			},
			loading: false,
			loadingMinTimeout: null,
			initialized: false,
			activeSectionId: null,
			paramGroups: null,
			currentSlide: 0,
			slidesToShow: undefined,
			headFixed: false,
			excludeSimilar: false,
			dragOn: false,
			dragStartPosition: undefined,
			dragOffsetReal: 0,
			dragOffset: 0,
			computedTransition: 'none',
			computedWidth: 'auto',
			widthOfItem: undefined,
			resizeTimeout: null
		};
	},

	computed: {
		...mapGetters({
			items: 'compare/items'
		}),

		sections() {
			if (!this.catalog || !this.catalog.items || !this.catalog.items.length) {
				return null;
			}
			let result = [];
			this.catalog.items.forEach(item => {
				result.push({
					id: item.sectionId,
					text: item.sectionName,
					count: 1
				});
			});
			return result;
		},

		currentSlideOffset() {
			return -this.currentSlide * 100 / this.slidesToShow + '%';
		},

		itemsCount() {
			return this.catalog.items.reduce((memo, item) => {
				if (item.sectionId === this.activeSectionId) {
					return memo + 1;
				} else {
					return memo;
				}
			}, 0);
		}
	},

	watch: {
		items() {
			this.requestDataLoad();
		}
	},

	created() {
		window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		window.addEventListener('resize', this.handleResize, controller.passiveEventsSupported ? {passive: true} : undefined);
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleResize);
	},

	methods: {
		slideItemsBack() {
			if (!this.isPrevArrowDisabled()) {
				this.currentSlide--;
			}
			this.computedTransition = 'transform .3s';
		},

		slideItemsForward() {
			if (!this.isNextArrowDisabled()) {
				this.currentSlide++;
			}
			this.computedTransition = 'transform .3s';
		},

		isPrevArrowDisabled() {
			return this.currentSlide === 0;
		},

		isNextArrowDisabled() {
			return this.currentSlide + this.slidesToShow >= this.itemsCount;
		},

		dragStart(e) {
			if (window.innerWidth <= breakpoints['2xs-max']) {
				return;
			}
			this.dragOn = true;
			this.dragStartPosition = e.touches[0].pageX;
			this.computedTransition = 'none';
			this.widthOfItem = this.$el.querySelector('.catalog-compare__head-item').offsetWidth;
		},

		dragEnd() {
			if (window.innerWidth <= breakpoints['2xs-max']) {
				return;
			}
			this.dragOn = false;
			this.computedTransition = 'transform .3s';
			this.currentSlide = Math.round((this.widthOfItem * this.currentSlide - this.dragOffset) / this.widthOfItem);
			if (this.currentSlide + this.slidesToShow >= this.itemsCount) {
				this.currentSlide = this.itemsCount - this.slidesToShow;
			}
			if (this.currentSlide < 0) {
				this.currentSlide = 0;
			}
			this.dragOffset = 0;
		},

		dragMove(e) {
			if (!this.dragOn) {
				return;
			}
			this.dragOffsetReal = e.touches[0].pageX - this.dragStartPosition;
			if (this.widthOfItem * this.currentSlide - this.dragOffsetReal < 0) {
				this.dragOffset = this.widthOfItem * this.currentSlide;
			} else {
				this.dragOffset = this.dragOffsetReal;
			}
		},

		recalcParams() {
			let vm = this;
			if (!this.catalog || !this.catalog.items || !this.catalog.items.length) {
				vm.paramGroups = null;
				return;
			}
			if (this.sections.length && (!this.activeSectionId || !this.sections.find(elem => elem.id === this.activeSectionId))) {
				this.activeSectionId = this.sections[0].id;
			}
			let result = {};
			// make empty params matrix including all params of all items
			this.catalog.items.forEach(item => {
				if (item.sectionId !== this.activeSectionId) {
					return;
				}
				item.params.forEach(paramGroup => {
					if (!result[paramGroup.id]) {
						result[paramGroup.id] = {
							id: paramGroup.id,
							title: paramGroup.title,
							open: true,
							params: {}
						};
					}
					paramGroup.params.forEach(param => {
						if (!result[paramGroup.id].params[param.id]) {
							result[paramGroup.id].params[param.id] = {
								id: param.id,
								title: param.title,
								tip: param.tip || null,
								values: []
							};
						}
					});
				});
			});
			// fill params matrix (fill gaps with null)
			Object.values(result).forEach(resultParamGroup => {
				Object.values(resultParamGroup.params).forEach(resultParam => {
					this.catalog.items.forEach(item => {
						if (item.sectionId !== this.activeSectionId) {
							return;
						}
						let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
						let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;
						resultParam.values.push(itemParamsValue);
					});
				});
			});
			// exclude similar
			if (vm.excludeSimilar) {
				result = Object.values(result).filter(resultParamGroup => {
					resultParamGroup.params = Object.values(resultParamGroup.params).filter(resultParam => {
						let testValue;
						let diffFound = false;
						this.catalog.items.forEach(item => {
							if (item.sectionId !== this.activeSectionId) {
								return;
							}
							if (!resultParamGroup || !resultParam) {
								return;
							}
							let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
							let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;
							if (typeof testValue == 'undefined') {
								testValue = itemParamsValue;
							} else if (!itemParamsValue || testValue.text !== itemParamsValue.text) {
								diffFound = true;
							}
						});
						return diffFound;
					});
					return resultParamGroup && resultParamGroup.params.length;
				});
			}
			vm.paramGroups = result;
		},

		tableScroll() {
			if (this.$refs.scrollContainer.scrollLeft !== this.$refs.headNav.scrollLeft) {
				this.$refs.headNav.scrollLeft = this.$refs.scrollContainer.scrollLeft;
			}
		},

		handleScroll() {
			if (this.$refs.headPlaceholder && this.$refs.compareBody) {
				this.headFixed = this.$refs.headPlaceholder.getBoundingClientRect().top <= 0 && this.$refs.compareBody.getBoundingClientRect().bottom >= 0;
			}
		},

		handleResize() {
			if (breakpoints['lg-max'] < window.innerWidth) {
				this.slidesToShow = 5;
			} else if (breakpoints['md-max'] < window.innerWidth && window.innerWidth <= breakpoints['lg-max']) {
				this.slidesToShow = 4;
			} else if (breakpoints['sm-max'] < window.innerWidth && window.innerWidth <= breakpoints['md-max']) {
				this.slidesToShow = 3;
			} else {
				this.slidesToShow = 2;
			}
			this.computedWidth = window.innerWidth <= breakpoints['2xs-max'] ? (this.itemsCount + 1) * 200 + 'px' : 'auto';
		},

		reset() {
			this.$store.dispatch('compare/remove', {
				id: 'all'
			});
		},

		dataSet(data) {
			this.catalog = data;
			this.recalcParams();
			this.$nextTick(() => {
				this.initialized = true;
			});
			this.handleResize();
			this.$nextTick(() => {
				clearInterval(this.resizeTimeout);
				this.resizeTimeout = setTimeout(() => {
					this.handleScroll();
				}, 200);
				setTimeout(() => {
					this.handleResize();
				}, 100);
			});
		},

		requestDataLoad() {
			if (this.catalog && this.catalog.remote) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true
				});
			}
		}
	}
};
</script>